// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zp5auX7PyKs4nmY6{border-radius:4px;border:1px solid var(--py-neutral-3);background-color:var(--py-neutral-0);padding:8px}.zp5auX7PyKs4nmY6:hover{background-color:var(--py-neutral-2);cursor:pointer}.zp5auX7PyKs4nmY6.JRQ9zbTBpRYJszQ5{border:2px solid var(--py-primary-5);padding:7px}.zp5auX7PyKs4nmY6.MeTAhJaiDfAFRsqQ{opacity:38%;cursor:not-allowed}.zp5auX7PyKs4nmY6:focus{outline:none}.zp5auX7PyKs4nmY6.XXwSEImrMPsdgBhO{background-color:var(--py-neutral-2)}.zp5auX7PyKs4nmY6.XXwSEImrMPsdgBhO:hover{background-color:var(--py-neutral-2);cursor:pointer}.SNW1wU2TfE024Ro5:active{transform:translateY(1px)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tagItem": `zp5auX7PyKs4nmY6`,
	"focused": `JRQ9zbTBpRYJszQ5`,
	"disabled": `MeTAhJaiDfAFRsqQ`,
	"selected": `XXwSEImrMPsdgBhO`,
	"animatedActive": `SNW1wU2TfE024Ro5`
};
export default ___CSS_LOADER_EXPORT___;
